import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { adminApi, fmtDate } from "@/api";

const ACTION_TAG = {
  validate: { label: "Validation", cls: "t-mut" },
  optimize: { label: "Optimisation", cls: "t-ok" },
  optimize_done: { label: "Terminée", cls: "t-ok" },
  optimize_no_profile: { label: "Sans profil", cls: "t-off" },
  optimize_no_uses: { label: "Sans utilisation", cls: "t-off" },
};

export default function LogsTab() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");

  const load = useCallback(async (f = filter) => {
    const v = f.trim();
    const params = { limit: 100 };
    if (v) {
      if (v.toUpperCase().startsWith("AQM-")) params.license_key = v;
      else params.hwid = v;
    }
    try {
      const r = await adminApi().get("/admin/logs", { params });
      setLogs(r.data);
    } catch {
      toast.error("Erreur de chargement des logs");
    }
  }, [filter]);

  useEffect(() => {
    const t = setTimeout(() => load(), 300);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <div className="card" data-testid="logs-tab">
      <div className="toolrow">
        <input
          placeholder="Filtrer par licence ou HWID…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          data-testid="logs-filter-input"
        />
      </div>
      <table data-testid="logs-table">
        <thead>
          <tr><th>Date</th><th>Action</th><th>Licence</th><th>Matériel</th><th>Profil</th></tr>
        </thead>
        <tbody>
          {logs.length === 0 && (
            <tr><td colSpan="5" style={{ color: "var(--faint)" }}>Aucun log.</td></tr>
          )}
          {logs.map((l, i) => {
            const a = ACTION_TAG[l.action] || { label: l.action, cls: "t-mut" };
            return (
              <tr key={i}>
                <td style={{ whiteSpace: "nowrap" }}>{fmtDate(l.ts)}</td>
                <td><span className={`tag ${a.cls}`}>{a.label}</span></td>
                <td className="mono" style={{ fontSize: 12 }}>
                  {l.license_key}
                  <div style={{ color: "var(--faint)", fontSize: 11 }}>{l.hwid}</div>
                </td>
                <td style={{ fontSize: 12.5 }}>
                  {l.board_model} — BIOS {l.bios_version}
                  <div style={{ color: "var(--faint)", fontSize: 11 }}>{l.cpu_model}</div>
                </td>
                <td className="mono" style={{ fontSize: 12 }}>
                  {l.profile_id || "—"}
                  {l.action === "optimize" && l.uses_remaining != null && (
                    <div style={{ color: "var(--faint)", fontSize: 11 }}>reste {l.uses_remaining} util.</div>
                  )}
                  {l.action === "optimize_done" && l.total != null && (
                    <div style={{ color: l.applied === l.total ? "var(--ok)" : "#F5A524", fontSize: 11, fontWeight: 600 }}>
                      {l.applied} / {l.total} paramètres
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
